import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./nav.css";

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const pathname = location.pathname;

  return (
    <nav
      className={`fixed md:fixed md:top-0 top-0 left-[78%] md:left-[33%] z-[10600] transition-colors duration-300 my-2 rounded-3xl ${
        isScrolled ? "md:bg-[#000000]" : "md:bg-transparent"
      }`}
    >
      <div className={`flex justify-between items-center px-10 py-2 text-white`}>
        {/* Logo */}
        <div></div>

        {/* Desktop Navigation Links */}
        <div className="hidden md:flex gap-[100px]">
          <span
            className={`cursor-pointer text-lg font-medium tracking-wide hover:underline hover:underline-offset-8 hover:decoration-4 hover:decoration-orange-600 ${
              pathname === "/"
                ? "rounded-xl  underline underline-offset-8 decoration-4 decoration-orange-600 text-white"
                : "text-white"
            }`}
            onClick={() => navigate("/")}
          >
            Home
          </span>
          <span
            className={`cursor-pointer text-lg font-medium tracking-wide hover:underline hover:underline-offset-8 hover:decoration-4 hover:decoration-orange-600 ${
              pathname === "/about"
                ? "rounded-xl  underline underline-offset-8 decoration-4 decoration-orange-600 text-white"
                : "text-white"
            }`}
            onClick={() => navigate("/about")}
          >
            About
          </span>
          <span
            className={`cursor-pointer text-lg font-medium tracking-wide hover:underline hover:underline-offset-8 hover:decoration-4 hover:decoration-orange-600 ${
              pathname === "/products" ||
              pathname === "/product/PearlReserve" ||
              pathname === "/product/ForestWhisper" ||
              pathname === "/product/PocketBrew"
                ? "rounded-xl  underline underline-offset-8 decoration-4 decoration-orange-600 text-white"
                : "text-white"
            }`}
            onClick={() => navigate("/products")}
          >
            Product
          </span>
          <span
            className={`cursor-pointer text-lg font-medium tracking-wide hover:underline hover:underline-offset-8 hover:decoration-4 hover:decoration-orange-600 ${
              pathname === "/contactus"
                ? "rounded-xl  underline underline-offset-8 decoration-4 decoration-orange-600 text-white"
                : "text-white"
            }`}
            onClick={() => navigate("/contactus")}
          >
            Contact Us
          </span>
        </div>

        {/* Hamburger Menu (Visible on Mobile) */}
        <div
          className="md:hidden cursor-pointer"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <div className="w-6 h-1 bg-white mb-1"></div>
          <div className="w-6 h-1 bg-white mb-1"></div>
          <div className="w-6 h-1 bg-white"></div>
        </div>
      </div>

      {/* Mobile Side Drawer */}
      {isMenuOpen && (
        <div className="fixed top-0 left-0 w-1/2 h-full bg-white bg-opacity-100 text-black z-50 p-6">
          <button
            className="text-black text-2xl absolute top-4 right-4"
            onClick={() => setIsMenuOpen(false)}
          >
            &times;
          </button>
          <div className="flex flex-col gap-6 mt-12">
            <span
              className="cursor-pointer hover:text-orange-500 text-lg font-semibold"
              onClick={() => {
                navigate("/");
                setIsMenuOpen(false);
              }}
            >
              Home
            </span>
            <span
              className="cursor-pointer hover:text-orange-500 text-lg font-semibold"
              onClick={() => {
                navigate("/about");
                setIsMenuOpen(false);
              }}
            >
              About
            </span>
            <span
              className="cursor-pointer hover:text-orange-500 text-lg font-semibold"
              onClick={() => {
                navigate("/products");
                setIsMenuOpen(false);
              }}
            >
              Product
            </span>
            <span
              className="cursor-pointer hover:text-orange-500 text-lg font-semibold"
              onClick={() => {
                navigate("/contactus");
                setIsMenuOpen(false);
              }}
            >
              Contact Us
            </span>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;